module.exports = __webpack_public_path__ + "img/camp-pick-lock.45ca03a7.svg";